import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/org/$organization/$project/app/$application/activity/contributors')({
    component: ()=>null
});
